module.exports = __webpack_public_path__ + "static/media/mode-2005.f8004d52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-2005.svg
// module id = 1047
// module chunks = 2